import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, CalendarCheck, LockKeyhole } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { BookingAccessForm } from "@/components/site/BookingAccessForm";
import { useWaNumber } from "@/components/site/WhatsAppFab";
import { STATUS_CLS } from "@/pages/MyBookings";
import { waLink } from "@/lib/api";

export default function BookingStatus() {
  const { t } = useLang();
  const { state } = useLocation();
  const number = useWaNumber();
  const [booking, setBooking] = useState(null);
  const resultRef = useRef(null);
  useEffect(() => {
    if (booking && window.matchMedia("(max-width: 639px)").matches) resultRef.current?.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth", block: "center" });
  }, [booking]);
  return (
    <section data-testid="booking-status-page" className="mx-auto max-w-5xl px-4 pt-12 pb-24 sm:px-6 sm:pb-12 lg:py-20">
      <div className="grid gap-10 lg:grid-cols-[1fr_1.1fr] lg:gap-16">
        <div>
          <span className="mb-6 inline-flex rounded-2xl bg-emerald-100 p-3 text-[#064E3B]"><CalendarCheck className="h-7 w-7" /></span>
          <h1 className="text-4xl font-extrabold leading-tight tracking-tight sm:text-5xl">{t("access_title")}</h1>
          <p className="mt-5 text-sm leading-relaxed text-slate-600 sm:text-base">{t("access_sub")}</p>
          <p data-testid="booking-status-privacy" className="mt-8 flex items-start gap-2 text-xs leading-relaxed text-slate-500"><LockKeyhole className="h-4 w-4 shrink-0" />{t("access_privacy")}</p>
          <Link data-testid="booking-status-login" to="/login?method=whatsapp&next=/bookings" className="mt-8 inline-flex items-center gap-2 text-sm font-bold text-[#064E3B] transition-colors hover:text-[#047857]">{t("access_login")}<ArrowRight className="h-4 w-4" /></Link>
        </div>
        <div className="min-w-0 rounded-3xl border border-slate-200 bg-white p-5 shadow-sm sm:p-8">
          <BookingAccessForm initialCode={state?.code || ""} onStart={() => setBooking(null)} onSuccess={setBooking} />
          {booking && <div ref={resultRef} role="status" aria-live="polite" data-testid="booking-status-result" className="mt-6 space-y-4 rounded-2xl border border-emerald-100 bg-emerald-50 p-5">
            <p data-testid="lookup-booking-code" className="break-all font-mono text-sm font-semibold text-slate-700">{booking.code}</p>
            <span data-testid="lookup-booking-status" className={`inline-flex rounded-full px-3 py-1 text-sm font-bold ${STATUS_CLS[booking.status]}`}>{t(`status_${booking.status}`)}</span>
            <p data-testid="lookup-status-explanation" className="text-sm leading-relaxed text-slate-600">{t(`access_${booking.status}`)}</p>
            {number && <a data-testid="lookup-contact-team" href={waLink(number, `${t("booking_code")}: ${booking.code}`)} target="_blank" rel="noreferrer" className="inline-flex text-sm font-bold text-[#064E3B] underline underline-offset-4">{t("access_help")}</a>}
          </div>}
        </div>
      </div>
    </section>
  );
}
